<section class="destination-flight-info relative ms-large-y">
  <div class="destination-flight-info__image grey-50-bg surface-disabled-bg relative overflow-hidden">
    @if (picture(); as picture) {
      <fin-content-image class="fill" [imageData$]="picture | finToObservable" [fillParent]="true" />
    }
  </div>

  @if (showCard()) {
    <div
      class="destination-flight-info__card md-grid-auto-cols white-bg frost elevation-level-1 overflow-hidden nordic-blue-900-text text-icon-primary g-medium ps-large"
    >
      @if (isLoading()) {
        <div class="destination-flight-info__card-loader col-f flex flex--center">
          <fcom-loader [loaderType]="LoaderTheme.INLINE" />
        </div>
      } @else {
        @if (showPriceColumn()) {
          <div class="destination-flight-info__column">
            <fcom-icon
              class="destination-flight-info__icon icon-large flex--shrink0"
              [name]="SvgLibraryIcon.FLIGHT_OFFER"
            />
            <span class="destination-flight-info__title font-title-medium ms-small-b">
              {{ 'ondMarketing.destinationFlightInfo.startingFrom' | finLocalization }}
            </span>
            <span class="destination-flight-info__label font-body-medium">
              {{
                (isRoundTrip()
                  ? 'ondMarketing.destinationFlightInfo.roundTrip'
                  : 'ondMarketing.destinationFlightInfo.oneWay'
                ) | finLocalization
              }}
            </span>
            @let price = startingFromPrice();
            @if (price) {
              <span class="destination-flight-info__value font-title-small" data-nosnippet>{{ price | finPrice }}</span>
            } @else {
              <span class="destination-flight-info__value font-title-small">
                <fin-skeleton-loader class="destination-flight-info__price-skeleton inline-block valign-middle">
                  <div class="destination-flight-info__price-skeleton-bar"></div>
                </fin-skeleton-loader>
              </span>
            }
          </div>
        }

        @if (duration(); as duration) {
          <div class="destination-flight-info__column">
            <fcom-icon class="destination-flight-info__icon icon-large flex--shrink0" [name]="SvgLibraryIcon.CLOCK" />
            <span class="destination-flight-info__title font-title-medium ms-small-b">
              {{ 'ondMarketing.destinationFlightInfo.flightTime' | finLocalization }}
            </span>
            <span class="destination-flight-info__label font-body-medium">
              {{ 'ondMarketing.destinationFlightInfo.approx' | finLocalization }}
            </span>
            <span class="destination-flight-info__value font-title-small">{{ duration | finDuration | async }}</span>
          </div>
        }

        @if (airportCodes().length) {
          <div class="destination-flight-info__column">
            <fcom-icon class="destination-flight-info__icon icon-large flex--shrink0" [name]="SvgLibraryIcon.AIRPORT" />
            <span class="destination-flight-info__title font-title-medium ms-small-b">
              {{ 'ondMarketing.destinationFlightInfo.airports' | finLocalization }}
            </span>
            @if (cityName(); as cityName) {
              <span class="destination-flight-info__label font-body-medium">{{ cityName }}</span>
            }
            <span class="destination-flight-info__value font-title-small">{{ airportCodes().join(', ') }}</span>
          </div>
        }

        @if (isDirect()) {
          <div class="destination-flight-info__column">
            <fcom-icon
              class="destination-flight-info__icon icon-large flex--shrink0"
              [name]="SvgLibraryIcon.CONNECTING_FLIGHT"
            />
            <span class="destination-flight-info__title font-title-medium ms-small-b">
              {{ 'ondMarketing.destinationFlightInfo.directFlights' | finLocalization }}
            </span>
            @let frequency = directFrequency();
            @if (frequency) {
              <span class="destination-flight-info__label font-body-medium" aria-hidden="true">
                {{ frequency.count }}
                <fcom-icon class="ms-xxsmall-x" [name]="SvgLibraryIcon.AIRCRAFT_HORIZONTAL" />
                {{ directFrequencyUnitKey() | finLocalization }}
              </span>
              <span class="is-vishidden">
                {{ directFrequencyKey() | finLocalization: { count: frequency.count } }}
              </span>
            }
          </div>
        }
      }
    </div>
  }

  @if (seasonalNotification(); as notification) {
    <fcom-notification class="block ms-medium-t">
      <p class="font-body-medium" [innerHTML]="notification.key | finLocalization: notification.params"></p>
    </fcom-notification>
  }
</section>
